import { configureStore } from '@reduxjs/toolkit';
import LoginSlice from './login';
import sidebarSlice from './sideBarState';

const store = configureStore({
    reducer: {
        login :LoginSlice.reducer,
    sidebar: sidebarSlice.reducer,
    //     order:createOrderSlice.reducer
        
  },
});

export default store;
